module.exports = __webpack_public_path__ + "static/media/ic_correct.c76f7793.svg";